<template>
  <div>
    <Header />
    <v-container>
      <v-row justify="center">
        <v-col cols="12" xl="10">
          <v-card>
            <v-card-title>Produkt Bearbeiten</v-card-title>
            <v-card-subtitle>Überprüfen Sie alle Felder</v-card-subtitle>
            <v-card-text>
              <v-form @submit.prevent="save">
                <v-tabs>
                  <v-tab>Allgemeine Informationen</v-tab>
                  <v-tab>Preise & Versand</v-tab>
                  <v-tab>Bilder</v-tab>

                  <v-tab-item>
                    <v-row>
                      <v-col cols="12" md="6">
                        <v-text-field
                          v-model="product.name"
                          label="Produkt Titel"
                          placeholder="Knoblauchpresse"
                          outlined
                        ></v-text-field>
                        <v-text-field
                          v-model="product.sku"
                          label="SKU"
                          placeholder="PY-2NBA-003"
                          outlined
                        ></v-text-field>
                        <v-text-field
                          v-model="product.externalSKU"
                          label="Externe SKU"
                          placeholder="PY-2NBA-003"
                          outlined
                        ></v-text-field>
                        <v-text-field
                          v-model="product.brand"
                          label="Marke"
                          placeholder="WMF"
                          outlined
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-text-field
                          v-model="product.stock"
                          label="Lagerbestand"
                          type="number"
                          outlined
                        ></v-text-field>
                        <v-text-field
                          v-model="product.plentyId"
                          label="Plenty Id"
                          type="number"
                          outlined
                        ></v-text-field>
                        <v-text-field
                          v-model="product.rawCode"
                          label="Rohprodukt"
                          outlined
                        ></v-text-field>
                        <v-select
                          v-model="product.billbeeWarehouseId"
                          :items="warehouses"
                          item-text="name"
                          item-value="id"
                          label="Billbee Lager"
                          outlined
                          clearable
                          hint="Wählen Sie ein spezifisches Lager für Abnahmevereinbarungen. Leer = Standard-Lager"
                          persistent-hint
                        ></v-select>
                        <v-textarea
                          v-model="product.description"
                          label="Beschreibung"
                          placeholder="Beschreibungstext"
                          outlined
                        ></v-textarea>
                        <v-switch
                          v-model="product.published"
                          :label="product.published ? 'Veröffentlicht' : 'Unveröffentlicht'"
                          color="primary"
                        ></v-switch>
                      </v-col>
                    </v-row>
                  </v-tab-item>

                  <v-tab-item>
                    <v-row>
                      <v-col cols="12" md="6">
                        <v-text-field
                          v-model="product.engravingPrice"
                          label="Gravurkosten (netto)"
                          type="number"
                          min="0.01"
                          step="0.01"
                          outlined
                        ></v-text-field>
                        <v-text-field
                          v-model="product.acdPrice"
                          label="ACD Preis"
                          type="number"
                          min="0.01"
                          step="0.01"
                          outlined
                        ></v-text-field>
                        <v-text-field
                          v-model="product.warehousePrice"
                          label="ERP Warehouse Price (Automatisch)"
                          type="number"
                          readonly
                          outlined
                        ></v-text-field>
                        <v-text-field
                          v-model="product.purchasingPrice"
                          label="Einkaufspreis"
                          type="number"
                          min="0.01"
                          step="0.01"
                          outlined
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-autocomplete
                          v-model="product.cartonId"
                          :items="cartons"
                          item-text="name"
                          item-value="id"
                          label="Karton"
                          @change="updateCartonPrice"
                          outlined
                        ></v-autocomplete>
                        <v-text-field
                          v-model="product.cartonPrice"
                          label="Karton Preis"
                          outlined
                        ></v-text-field>
                        <v-subheader>Versandkosten</v-subheader>
                        <v-list>
                          <v-list-item v-for="(data, index) in product.shipping" :key="index">
                            <v-list-item-content>
                              <v-row>
                                <v-col cols="5">
                                  <v-text-field v-model="data.country" label="Land" placeholder="DE"></v-text-field>
                                </v-col>
                                <v-col cols="5">
                                  <v-text-field v-model="data.price" label="Preis (in Cent)" type="number"></v-text-field>
                                </v-col>
                                <v-col cols="2">
                                  <v-btn icon @click="removeShipping(index)"><v-icon>mdi-delete</v-icon></v-btn>
                                </v-col>
                              </v-row>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                        <v-btn @click="addShipping" color="primary">Land hinzufügen</v-btn>
                      </v-col>
                    </v-row>
                  </v-tab-item>

                  <v-tab-item>
                    <v-row>
                      <v-col cols="12" md="6">
                        <v-card-title>Produktbild</v-card-title>
                        <v-image-input
                          v-model="imageData"
                          :image-quality="1"
                          imageMinScaling="contain"
                          clearable
                          image-format="png"
                        />
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-card-title>Galerie</v-card-title>
                        <!-- Hier können Sie eine Galerie-Komponente hinzufügen -->
                      </v-col>
                    </v-row>
                  </v-tab-item>
                </v-tabs>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn @click="save" color="primary" :loading="loading">Änderungen speichern</v-btn>
                  <v-btn @click="deleteProduct" color="error" :loading="loading">Produkt löschen</v-btn>
                </v-card-actions>
              </v-form>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import Header from "@/views/general/header";
import router from "@/plugins/router";
import AssetService from "@/services/AssetService";
import ProductService from "@/services/ProductService";
import CartonService from "@/services/ShippingCartonService";

export default {
  name: "ProductEdit",
  components: {
    Header
  },
  data: () => ({
    loading: false,
    imageData: null,
    cartons: [],
    warehouses: [
      { id: null, name: 'Standard-Lager (Standard)' },
      { id: 20035, name: 'Standard-Lager (20035)' },
      { id: 53148, name: 'ABN-V_Kooperation (53148)' }
    ],
    product: {
      id: null,
      name: "",
      sku: "",
      externalSKU: "",
      plentyId: "",
      brand: "",
      published: false,
      stock: 0,
      description: "",
      rawCode: "",
      shipping: [],
      engravingPrice: 0,
      acdPrice: 0,
      warehousePrice: 0,
      purchasingPrice: 0,
      cartonId: null,
      cartonPrice: 0,
      billbeeWarehouseId: null
    }
  }),
  mounted() {
    this.refresh();
  },
  methods: {
    addShipping() {
      this.product.shipping.push({ country: "", price: 0 });
    },
    removeShipping(index) {
      this.product.shipping.splice(index, 1);
    },
    async uploadImage() {
      try {
        this.loading = true;
        let res = (await AssetService.upload(this.imageData)).data;
        this.product.imageId = res.id;
        this.loading = false;
      } catch (err) {
        this.loading = false;
        throw err;
      }
    },
    async updateCartonPrice() {
      let carton = this.cartons.find(x => x.id == this.product.cartonId);
      this.product.cartonPrice = carton.price;
    },
    async refresh() {
      this.loading = true;
      try {
        this.product = (await ProductService.getProduct(this.$route.params.id, this.$route.params.productId)).data;
        this.cartons = (await CartonService.getAll()).data;
        this.imageData = await AssetService.getAsBase64(this.product.imageId);
        this.loading = false;
      } catch (err) {
        if (err.response.status == 401) {
          router.replace("/auth/login");
        }
      }
    },
    async save() {
      this.loading = true;
      try {
        let productPayload = { ...this.product };
        delete productPayload.shipping;

        let res = (await AssetService.upload(this.imageData)).data;
        productPayload.imageId = res.id;

        await ProductService.update(this.product.appId, this.product.id, productPayload);

        let pricingPayload = {
          engravingPrice: this.product.engravingPrice,
          acdPrice: this.product.acdPrice,
          warehousePrice: this.product.warehousePrice,
          purchasingPrice: this.product.purchasingPrice,
          shipping: this.product.shipping
        };

        await ProductService.updatePricing(this.$route.params.id, this.product.id, pricingPayload);

        router.push({ name: "Products", params: { id: this.$route.params.id } });
      } catch (err) {
        if (err.response && err.response.status == 401) {
          router.replace("/auth/login");
        }
      } finally {
        this.loading = false;
      }
    },
    async deleteProduct() {
      try {
        this.loading = true;
        await ProductService.deleteProduct(this.$route.params.id, this.product.id);
        router.push({ name: "Products" });
      } catch (err) {
        alert(err);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>